import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as NegotiationActions from '../../../actions/NegotiationActions';
import { ApportionmentType } from '../../../constants';
import { ValidationService } from '../../../services';
import Modal from 'react-responsive-modal';
import debounce from '../../../services/DebounceService';
import Select from 'react-select';
import { Messages } from '../../../constants';
import Alert from 'react-s-alert';
import validation from './validation';
import validationRateio from './validationRateio';
import Switch from 'react-switch';
import Autocomplete from 'react-autocomplete';
import NumberFormat from 'react-number-format';
import Loader from '../../../components/Loader';
import moment from 'moment';
import './style.scss';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
registerLocale('pt-BR', ptBr);

class AddNegotiation extends Component {
  state = {
    uploadSharepoint:0,
    openDigital: false,
    openOthersVehicles: false,
    testeText: '',
    


  };

  componentDidMount = () => {
    if (this.props.loggedUser.executive.idExecutivo <= 0)
      this.props.userIsNotExecutive();

    this.props.fillVehicles(ApportionmentType.OtherVehicle);
    this.props.fillMainVehicles();
    this.props.fillNatures();
    this.props.fillSalesTypes();
    this.props.fillSalesOrigin();
    //this.props.fillpriceTable();
    this.props.fillPaymentTypes();
    this.props.fillCommercialPlans();
    this.props.fillToken();

  

    if (this.props.loggedUser.executive.perfilExecutivo != 'A')
      this.props.fillExecutive(this.props.loggedUser.executive);
  };

  onOpenModalDigital = () => {
    if (this.props.negotiaton.totalAmount <= 0) {
      Alert.error(Messages.RequiredTotalAmountForRegiterRateioMessage);
    } else {
      this.setState({ openDigital: true });
      this.props.redirectToRegister(ApportionmentType.Digital);
    }
  };

  onCloseModalDigital = () => {
    this.setState({ openDigital: false });
  };



  onCloseModalDigitalButton = () => {
    this.setState({ openDigital: false });

    if (this.props.apportionment.editing) {
      this.handleSubmitDigital();
    } else {
      this.clearDigital();
      this.handleChange('withDigital', false);
    }
  };

  onOpenOthersVehicles = () => {
    if (this.props.negotiaton.totalAmount <= 0) {
      Alert.error(Messages.RequiredTotalAmountForRegiterRateioMessage);
    } else {
      this.setState({ openOthersVehicles: true });
      this.props.redirectToRegister(ApportionmentType.OtherVehicle);
    }
  };

  onCloseModalOtherVechiles = () => {
    this.setState({ openOthersVehicles: false });
  };

  onCloseModalOtherVechilesButton = () => {
    this.setState({ openOthersVehicles: false });
    if (this.props.apportionment.editing) {
      this.handleSubmitDigital();
    } else if (
      this.props.negotiaton.apportionments.length === 0 ||
      (this.props.negotiaton.apportionments.length === 1 &&
        this.props.negotiaton.withDigital)
    ) {
      this.clearOtherVehicles();
      this.handleChange('withOthersVehicles', false);
    }
  };

  clearDigital = () => {
    this.props.clearDigital();
  };

  clearOtherVehicles = () => {
    this.props.clearOtherVehicles();
  };

  selectedClient = client => {
    this.props.selectedClient(client);
  };

  changedClienteSearch = searchTerm => {
    this.props.changedClienteSearch(searchTerm);
    this.updateClientOptions(searchTerm);
  };

  updateClientOptions = debounce(searchTerm => {
    if (searchTerm && searchTerm.length >= 2) {
      this.props.updateClientOptions(searchTerm);
    } else {
      this.props.clearClientOptions();
    }
  }, 600);

  selectedAgency = agency => {
    this.props.selectedAgency(agency);
  };

  changedAgencySearch = searchTerm => {
    this.props.changedAgencySearch(searchTerm);
    this.updateAgencyOptions(searchTerm);
  };

  updateAgencyOptions = debounce(searchTerm => {
    if (searchTerm && searchTerm.length >= 2)
      this.props.updateAgencyOptions(searchTerm);
    else this.props.clearAgencyOptions();
  }, 600);

  redirectToSelectComprehennsiveness = () => {
    this.props.redirectToSelectComprehennsiveness();

  };

  close = () => {
    this.props.redirectToNegoationList();
  };

  formIsValid = () =>
    ValidationService.validate(
      {
        ...this.props.negotiaton,
        clientSearch: this.props.clientSearch
      },
      validation
    );

  formRateioIsValid = () =>
    ValidationService.validate(this.props.apportionment, validationRateio);

  handleSubmit = event => {
    event.preventDefault();

    if (!this.formIsValid()) return;

    if (this.props.loading) return;
    if (!this.props.clientSearch && !this.props.negotiaton.client) {
      Alert.error(Messages.RequiredClientValidationMessage);
      return;
    }
    if (
      this.props.negotiaton.withDigital ||
      this.props.negotiaton.withOthersVehicles
    ) {
      const apportionments = this.props.negotiaton.apportionments;
      if (!apportionments || apportionments.length === 0) {
        Alert.error(Messages.NegotiationApportionmentRequired);
        return;
      }

      if (this.props.negotiaton.remainingValue <= 0) {
        Alert.error(Messages.NegotiationApportionmentInvalid);
        return;
      }
    }
    this.props.saveNegotiation(this.props.negotiaton, this.props.clientSearch, this.props.loggedUser, this.props.token.profile.name);
  };

  handleChangeMoney = (prop, value) => {
    this.props.updateNegotiationField({
      prop,
      value,
      totalAmount: this.props.negotiaton.totalAmount
    });
  };

  handleChange = (prop, value) => {
    this.props.updateNegotiationField({ prop, value });
  };

  handleChageSelect = (prop, event, list, veiculo) => {
    
    const value = event.target.value
      ? list.find(
          i => i._id == event.target.value || i.id == event.target.value
        )
      : {};
    this.props.updateNegotiationField({ prop, value });
    if(veiculo == 'idveiculo'){
      this.handleChangeMainVehicle(event.target.value);
    }


  };

  handleChageExecutive = (event) => {
    const value = event.target.value
      ? this.props.loggedUser.executive.identificacao.find(
          i => i.idExecutivo == event.target.value
        )
      : {};
    this.props.fillExecutive(value);
  };


  handleChangeMoneyRateio = (prop, value) => {
    if (prop === 'amount' && value === this.props.apportionment.amount) return;
    if (prop === 'percent' && value === this.props.apportionment.percent)
      return;

    this.props.updateApportionmentAmountField({
      prop,
      value,
      totalAmount: this.props.negotiaton.totalAmount
    });
  };

  handleSubmitDigital = event => {
    if (event) event.preventDefault();
    if (!this.formRateioIsValid()) return;
    if (
      this.props.negotiaton.remainingValue <= this.props.apportionment.amount
    ) {
      Alert.error(Messages.NegotiationApportionmentExceed);
      return;
    }

    this.props.addApportioment(this.props.apportionment);
    this.props.redirectToApportioment();
    this.onCloseModalDigital();

    if (this.props.apportionment.editing) this.onCloseModalOtherVechiles();
  };

  removeApportionment = apportionment => {
    this.props.removeApportionment(apportionment);
    if (apportionment.type === ApportionmentType.Digital)
      this.handleChange('withDigital', false);
    else if (
      this.props.negotiaton.apportionments.length === 1 ||
      (this.props.negotiaton.apportionments.length === 2 &&
        this.props.negotiaton.withDigital)
    )
      this.handleChange('withOthersVehicles', false);
  };

  editApportionment = apportionment => {
    this.props.removeApportionment(apportionment);
    this.props.fillApportionment(apportionment);
    if (apportionment.type === ApportionmentType.Digital)
      this.setState({ openDigital: true });
    else this.setState({ openOthersVehicles: true });
  };

  handleChangeRateio = (prop, event) => {
    const { value } = event.target;
    const vehicle = this.props.vehicles.find(v => v.id == value);
    this.props.updateApportionmentField({ prop, value: vehicle || {} });
  };

  handleChangeSalesOrigin = (prop, event) => {
    const { value } = event.target
    this.props.updateSalesOrigin(value);

  };

  handleChangeMainVehicle = (id) => {
    this.props.fillpriceTable(id)
    this.props.fillComprehensiveness(id);
  };

  addApportionment = () => {
    this.onOpenOthersVehicles();
  };

 

  finalaze = () => {
    if (
      this.props.negotiaton.apportionments.length === 0 ||
      (this.props.negotiaton.apportionments.length === 1 &&
        this.props.negotiaton.withDigital)
    )
      Alert.error(Messages.NegotiationApportionmentNotRegister);
    else this.onCloseModalOtherVechiles();
  };

  HandleChangeSharepoint = (event) => {
    const { value } = event.target;
    if(value == 1){
      this.props.ChangeValueSharepointSave('S');
      this.props.InputTextSharepoint('Respondeu sim');

    } else if(value == 2){
      this.props.ChangeValueSharepointSave('N');
      this.props.InputTextSharepoint('');

    } else {
      this.props.InputTextSharepoint('');
      this.props.ChangeValueSharepointSave ('');
    }
    this.setState({ uploadSharepoint: value });
  };


  HandleChangeInputTextSharepoint = (e) => {
    const { value } = e.target;
    this.props.InputTextSharepoint(value);
  };


  

  render = () => (
    <div className="register-pre-sale" >
      <Loader />
      <div className="row content-box">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 right-column">
          <div className="title-form">
            <div className="close close-box" onClick={this.close}>
              <i className="fas fa-times-circle icon-close" />
            </div>
            <div className="title-text">
              <p className="text txt-register">Cadastro</p>
              <p className="text txt-new">Pré-venda</p>

            </div>
          </div>
          <div className="form-container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right msg-info">
                <span className="text required-text">
                  campos obrigatórios *

                </span>
              </div>
            </div>
            <form onSubmit={this.handleSubmit}>
           {/*    <h1>{"Origem de Venda Id: " + this.props.negotiaton.salesOrigin.id}</h1>
             <h1>{"Origem de Venda Nome: " + this.props.negotiaton.salesOrigin.nome}</h1>
             <h1>{"Veiculo Nome: " + this.props.negotiaton.mainVehicle.nome}</h1>  */}
             {/* <h1>{"Veiculo Id: " + this.props.negotiaton.mainVehicle.id}</h1> */}


            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
              <select
                className="form-control"
                value={this.props.negotiaton.salesOrigin.id}
                name="origemVenda"
                onChange={
                  ev =>
                  this.handleChageSelect(
                    'salesOrigin',
                    ev,
                    this.props.salesOriginOptions
                  )
                  }
              >
                <option>Origem de Venda *</option>
                {this.props.salesOriginOptions.map(ov => (
                  <option key={ov.id} value={ov.id}>
                    {ov.nome}
                  </option>
                ))}
              </select>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                <Select
                  isLoading={this.props.loadingAgencies}
                  placeholder={"Agências *"}
                  value={this.props.negotiaton.agency}
                  onChange={e => this.selectedAgency(e)}
                  onInputChange={this.changedAgencySearch}
                  options={this.props.agencyOptions}
                  isMulti={true}
                  styles={{
                    input: () => ({
                      boxShadow: 'none'
                    })
                  }}
                  loadingMessage={() => 'Buscando...'}
                  noOptionsMessage={() => this.props.agencySearch ? 'Nenhuma opção disponível encontrada' : 'Digite o nome da agência desejada'}
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                  <label className="text lbl-text" />
                  <select
                  className="form-control"
                  name="veiculo"
                  value={this.props.negotiaton.mainVehicle.id}
                  onChange={
                    ev =>
                    this.handleChageSelect(
                      'mainVehicle',
                      ev,
                      this.props.mainVehicleOptions,
                      'idveiculo'
                    )
                  }

                >
                  <option value="">Veículo *</option>
                  {this.props.mainVehicleOptions.map(n => (
                    <option key={n.id} value={n.id}>
                      {n.nome}
                    </option>
                  ))}
                </select>
                </div>

              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group autocomplete-agency with-border">
                <label className="text lbl-text" />
                <Autocomplete
                  wrapperStyle={{
                    position: 'relative',
                    display: 'inline-block'
                  }}
                  inputProps={{
                    placeholder: 'Cliente (CNPJ ou Nome) *',
                    className: 'form-control'
                  }}
                  getItemValue={item => item.nome}
                  items={this.props.clientOptions}
                  value={this.props.clientSearch}
                  onChange={e => this.changedClienteSearch(e.target.value)}
                  onSelect={(value, item) => this.selectedClient(item)}
                  renderMenu={children => (
                    <div className="menu">{children}</div>
                  )}
                  renderItem={item => (
                    <div className={'text item'} key={item.id}>
                      {`${item.nome || item.razaoSocial} - ${item.uf || ''} - ${item.cidade || ''} - ${item.cnpj || item.cpf || ''} - ${item.logradouro || ''}, ${item.numero || ''}`}
                    </div>
                  )}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <select
                  className="form-control"
                  name="planos"
                  value={this.props.negotiaton.commercialPlan._id}
                  onChange={ev =>
                    this.handleChageSelect(
                      'commercialPlan',
                      ev,
                      this.props.commercialPlansOptions
                    )
                  }
                >
                  <option value="">Plano Comercial</option>
                  {this.props.commercialPlansOptions.map(c => (
                    <option key={c._id} value={c._id}>
                      {c.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <select
                  className="form-control"
                  name="tipoVenda"
                  value={this.props.negotiaton.salesType.id}
                  onChange={ev =>
                    this.handleChageSelect(
                      'salesType',
                      ev,
                      this.props.salesTypesOptions
                    )
                  }
                >
                  <option value="">Tipo de Venda *</option>
                  {this.props.salesTypesOptions.map(n => (
                    <option key={n.id} value={n.id}>
                      {n.nome}
                    </option>
                  ))}
                </select>
              </div>
                  {this.props.negotiaton.mainVehicle.id ?
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group has-feedback with-border"
                      onClick={this.redirectToSelectComprehennsiveness}
                      >
                      <label className="text lbl-text" />
                      <input
                        type="text"
                        className="form-control pointer"
                        name="abrangencias"
                        placeholder={`Selecionar Abrangências (${
                          this.props.negotiaton.comprehensiveness.length
                        })`}
                      />
                      <i className="fas fa-external-link-alt form-control-feedback icon-inside-form pointer" />
                    </div>
                    :
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group has-feedback with-border"
                      >
                      <label className="text lbl-text" />
                      <input
                        type="text"
                        className="form-control pointer"
                        name="abrangencias"
                        placeholder={`Selecionar Abrangências (${
                          this.props.negotiaton.comprehensiveness.length
                        })`}
                      />
                      <span className="erro-abrangencia">Selecione o Veículo para escolher a abrangência. </span>
                      <i className="fas fa-external-link-alt form-control-feedback icon-inside-form pointer" />
                    </div>
                  }


              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-label has-feedback with-border">
                <label className="text lbl-text">Flight</label>
                <DatePicker
                  locale="pt-BR"
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  selected={this.props.negotiaton.beginDate}
                  onChange={date => {
                    this.handleChange('beginDate', date);
                    this.handleChange('endDate', null);
                  }}
                  placeholderText="Data de Início *"
                />
                <i className="fas fa-calendar-alt calendar-icon form-control-feedback icon-inside-form icon-label" />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group has-feedback with-border">
                <label className="text lbl-text" />
                <DatePicker
                  locale="pt-BR"
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  selected={this.props.negotiaton.endDate}
                  onChange={date => this.handleChange('endDate', date)}
                  placeholderText="Data de Fim *"
                  minDate={this.props.negotiaton.beginDate}
                />
                <i className="fas fa-calendar-alt calendar-icon form-control-feedback icon-inside-form icon-label" />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <select
                  className="form-control"
                  name="tabela"
                  value={this.props.negotiaton.table.id}
                  onChange={ev =>
                    this.handleChageSelect(
                      'table',
                      ev,
                      this.props.priceTableOptions,

                    )
                  }
                >
                  <option value="">Tabela *</option>
                  {this.props.priceTableOptions.map(t => (
                    <option key={t.id} value={t.id}>
                      {t.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <select
                  className="form-control"
                  name="formaPagamento"
                  value={this.props.negotiaton.paymentType.id}
                  onChange={ev =>
                    this.handleChageSelect(
                      'paymentType',
                      ev,
                      this.props.paymentTypeOptions
                    )
                  }
                >
                  <option value="">Forma de Pagamento *</option>
                  {this.props.paymentTypeOptions.map(p => (
                    <option key={p.id} value={p.id}>
                      {p.nome}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <NumberFormat
                  placeholder="Valor Total *"
                  className="form-control"
                  allowNegative={false}
                  fixedDecimalScale={true}
                  decimalSeparator={','}
                  thousandSeparator={'.'}
                  decimalScale={2}
                  prefix={'R$ '}
                  value={this.props.negotiaton.totalAmount}
                  onValueChange={e => {
                    this.handleChangeMoney('totalAmount', e.floatValue);
                    this.clearOtherVehicles();
                    this.clearDigital();
                    this.handleChange('withOthersVehicles', false);
                    this.handleChange('withDigital', false);
                  }}
                />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-border">
                <label className="text lbl-text" />
                <NumberFormat
                  placeholder={`Desconto ${
                    this.props.negotiaton.nature &&
                    ['PERMUTA NAO PATRIMONIAL', 'PERMUTA PATRIMONIAL'].indexOf(
                      this.props.negotiaton.nature.nome
                    ) === -1
                      ? '*'
                      : ''
                  }`}
                  className="form-control"
                  allowNegative={false}
                  fixedDecimalScale={true}
                  decimalSeparator={'.'}
                  decimalScale={2}
                  suffix={' %'}
                  value={this.props.negotiaton.discount}
                  onValueChange={e =>
                    this.handleChangeMoney('discount', e.floatValue)
                  }
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 with-border">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group nature">
                  <label className="text lbl-text" />
                  <select
                    className="form-control"
                    name="formaPagamento"
                    value={this.props.negotiaton.nature.id}
                    onChange={ev =>
                      this.handleChageSelect(
                        'nature',
                        ev,
                        this.props.naturesOptions
                      )
                    }
                  >
                    <option value="">Natureza *</option>
                    {this.props.naturesOptions.map(n => (
                      <option key={n.id} value={n.id}>
                        {n.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group switch-box with-border">

                {/* <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group left-box">
                  <label className="text lbl-text lbl-switch">
                    Tem Digital
                  </label>
                  <Switch
                    onChange={e => {
                      const value = !this.props.negotiaton.withDigital;
                      if (!value || this.props.negotiaton.totalAmount > 0)
                        this.handleChange('withDigital', value);
                      if (!value) this.clearDigital(value);
                      else this.onOpenModalDigital();
                    }}
                    checked={this.props.negotiaton.withDigital}
                    onColor={'#39b54a'}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    className="switch"
                  />
                  <span className="text switch-indication">
                    {this.props.negotiaton.withDigital ? 'Sim' : 'Não'}
                  </span>
                </div> */}
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group right-box">
                  <label className="text lbl-text lbl-switch">
                    Tem Outros Veículos
                  </label>
                  <Switch
                    onChange={e => {
                      const value = !this.props.negotiaton.withOthersVehicles;
                      if (!value || this.props.negotiaton.totalAmount > 0)
                        this.handleChange('withOthersVehicles', value);
                      if (!value) this.clearOtherVehicles();
                      else this.onOpenOthersVehicles();
                    }}
                    checked={this.props.negotiaton.withOthersVehicles}
                    onColor={'#39b54a'}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    className="switch"
                  />


                  <span className="text switch-indication">
                    {this.props.negotiaton.withOthersVehicles ? 'Sim' : 'Não'}
                  </span>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group switch-box with-border">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 form-group left-box empty" />
              </div>
              {this.props.negotiaton.apportionments &&
                this.props.negotiaton.apportionments.length > 0 && (
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group table-rateio">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Tipo</th>
                            <th>Veículo</th>
                            <th>Rateio %</th>
                            <th>Rateio R$</th>
                            <th />
                            <th />
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.negotiaton.apportionments.map(d => (
                            <tr key={d.vehicle.id}>
                              <td>
                                {d.type === ApportionmentType.Digital
                                  ? ApportionmentType.Digital
                                  : 'Outro Veículo'}
                              </td>
                              <td>{d.vehicle.nome}</td>
                              <td>
                                <NumberFormat
                                  value={d.percent}
                                  displayType={'text'}
                                  decimalSeparator={','}
                                  thousandSeparator={'.'}
                                  suffix={' %'}
                                  fixedDecimalScale
                                  decimalScale={2}
                                />
                              </td>
                              <td>
                                <NumberFormat
                                  value={d.amount}
                                  displayType={'text'}
                                  decimalSeparator={','}
                                  thousandSeparator={'.'}
                                  prefix={' R$ '}
                                  fixedDecimalScale
                                  decimalScale={2}
                                />
                              </td>
                              <td>
                                {d.type === ApportionmentType.OtherVehicle && (
                                  <i
                                    className="fas fa-plus-circle icon-rateio"
                                    onClick={() => this.addApportionment()}
                                  />
                                )}
                              </td>
                              <td>
                                <i
                                  className="fas fa-pencil-alt icon-rateio"
                                  onClick={() => this.editApportionment(d)}
                                />
                              </td>
                              <td>
                                <i
                                  className="fas fa-trash-alt icon-rateio"
                                  onClick={() => this.removeApportionment(d)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 form-group has-feedback with-border">
                <label className="text lbl-text">Data de Criação </label>
                <input
                  type="text"
                  className="form-control"
                  name="creationDate"
                  value={moment().format('DD/MM/YYYY HH:mm')}
                  disabled
                />
                <i className="fas fa-lock form-control-feedback icon-inside-form icon-label" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 form-group executive-box with-border">
                <label className="text lbl-text">Nome</label>
                {this.props.loggedUser.executive.perfilExecutivo === 'A' && (
                  <select
                    className="form-control"
                    name="executive"
                    value={this.props.negotiaton.executive.idExecutivo}
                    onChange={event => this.handleChageExecutive(event)}
                  >
                    <option value="">Selecione *</option>
                    {this.props.loggedUser.executive.identificacao.map(c => (
                      <option key={c.idExecutivo} value={c.idExecutivo}>
                        {c.nomeExecutivo}
                      </option>
                    ))}
                  </select>
                )}
                {this.props.loggedUser.executive.perfilExecutivo !== 'A' && (
                  <select
                    className="form-control"
                    name="executive"
                    value={this.props.negotiaton.executive.nomeExecutivo}
                  >
                    <option value="">{this.props.negotiaton.executive.nomeExecutivo}</option>
                  </select>
                )}
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 form-group username-box">
                <label className="text lbl-text">Incluído Por</label>
                  <input
                    type="text"
                    className="form-control"
                    name="creationUser"
                    value={this.props.token.profile.name}
                    disabled
                  />
                </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group with-border">
                

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 form-group username-box">
                <label className="text lbl-text">Upload no Sharepoint? </label>
                 <select
                 name="saveSharepointSelect"
                  className="form-control"
                  value = {this.props.sharepointOptions.id}
                  onChange={event => this.HandleChangeSharepoint(event)}
                  >
                   <option value="">Selecione *</option>
                   {this.props.sharepointOptions.map(item =>(
                     <option key={item.id} value={item.id}>
                       {item.name}
                     </option>
                   ))}
                 </select>
                </div>

                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 form-group username-box">
                 {this.state.uploadSharepoint == 2 &&
                 <>
                  <label className="text lbl-text">Descreva o motivo de não fazer o Upload no Sharepoint </label>

                  <input
                   className="form-control"
                    placeholder="Descreva o motivo de não fazer o Upload no Sharepoint *"
                    onChange={e => this.HandleChangeInputTextSharepoint(e)}
                  />
                  </>
                  
                 }
                </div>

        
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group btn-box">
                <button
                  type="button"
                  className="btn-normal btn-cancell"
                  onClick={this.close}
                >
                  CANCELAR
                </button>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group btn-box">
                <button type="submit" className="btn-normal btn-submit">
                  SALVAR
                </button>
              </div>
              <div className="text-center" />
            </form>
          </div>
        </div>
      </div>
      <div>
        <Modal
          showCloseIcon={false}
          open={this.state.openDigital}
          onClose={this.onCloseModalDigitalButton}
          styles={{
            overlay: {
              background: 'transparent'
            },
            modal: {
              borderRadius: '15px',
              border: '1px solid #e0e0e0'
            }
          }}
          center
        >
          <div className="row content-box">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 right-column rateio-box">
              <div className="title-form">
                <div
                  className="close close-box no-opacity"
                  onClick={this.onCloseModalDigitalButton}
                >
                  <i className="fas fa-times-circle close-top" />
                </div>
                <div className="title-text">
                  <p className="text rateio-title">Cadastro</p>
                  <p className="text title-rateio">Rateio para Digital</p>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-amount text-center with-border">
                <span className="text">
                  Valor Total:
                  <NumberFormat
                    className="information-value"
                    value={this.props.negotiaton.totalAmount}
                    displayType={'text'}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={' R$ '}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </span>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 remaning-amount text-center with-border">
                <span className="text">
                  Você ainda tem{' '}
                  <NumberFormat
                    className="information-value"
                    value={this.props.negotiaton.remainingValue}
                    displayType={'text'}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={' R$ '}
                    fixedDecimalScale
                    decimalScale={2}
                  />{' '}
                  disponível
                </span>
              </div>
            </div>
            <div className="form-container with-border">
              <form onSubmit={this.handleSubmitDigital}>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                  <label className="text lbl-text">Rateio R$</label>
                  <NumberFormat
                    className="form-control"
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    decimalScale={2}
                    prefix={'R$ '}
                    value={this.props.apportionment.amount}
                    onValueChange={e =>
                      this.handleChangeMoneyRateio('amount', e.floatValue)
                    }
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-label">
                  <label className="text lbl-text">Rateio %</label>
                  <NumberFormat
                    className="form-control"
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalSeparator={'.'}
                    decimalScale={2}
                    suffix={' %'}
                    value={this.props.apportionment.percent}
                    onValueChange={e =>
                      this.handleChangeMoneyRateio('percent', e.floatValue)
                    }
                  />
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group text-center">
                  <button type="submit" className="btn-submit-rateio">
                    SALVAR
                    <i className="fas fa-plus-circle plus-icon" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        <Modal
          showCloseIcon={false}
          open={this.state.openOthersVehicles}
          onClose={this.onCloseModalOtherVechilesButton}
          styles={{
            overlay: {
              background: 'transparent'
            },
            modal: {
              borderRadius: '15px',
              border: '1px solid #e0e0e0'
            },
            closeIcon: {
              color: '#fffffff'
            }
          }}
          center
        >
          <div className="row content-box">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 right-column rateio-box">
              <div className="title-form">
                <div
                  className="close close-box no-opacity"
                  onClick={this.onCloseModalOtherVechilesButton}
                >
                  <i className="fas fa-times-circle icon-close close-top" />
                </div>
                <div className="title-text">
                  <p className="text rateio-title">Cadastro</p>
                  <p className="text title-rateio">Rateio para Veículos</p>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 total-amount text-center">
                <span className="text">
                  Valor Total:
                  <NumberFormat
                    className="information-value"
                    value={this.props.negotiaton.totalAmount}
                    displayType={'text'}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={' R$ '}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </span>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 remaning-amount text-center">
                <span className="text">
                  Você ainda tem{' '}
                  <NumberFormat
                    className="information-value"
                    value={this.props.negotiaton.remainingValue}
                    displayType={'text'}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={' R$ '}
                    fixedDecimalScale
                    decimalScale={2}
                  />{' '}
                  disponível
                </span>
              </div>
            </div>
            <div className="form-container">
              <form onSubmit={this.handleSubmitDigital}>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                  <label className="text lbl-text" />
                  <select
                    value={this.props.apportionment.vehicle.id}
                    className="form-control"
                    name="vehicle"
                    onChange={ev => this.handleChangeRateio('vehicle', ev)}
                  >
                    {this.props.apportionment.type !==
                      ApportionmentType.Digital && (
                      <option value="">Selecione</option>
                    )}
                    {this.props.vehicles
                      .filter(
                        v =>
                          this.props.negotiaton.apportionments.filter(
                            a => a.vehicle.id == v.id
                          ).length === 0
                      )
                      .map(v => (
                        <option key={v.id} value={v.id}>
                          {v.nome}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group">
                  <label className="text lbl-text">Rateio R$</label>
                  <NumberFormat
                    className="form-control"
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    decimalScale={2}
                    prefix={'R$ '}
                    value={this.props.apportionment.amount}
                    onValueChange={e =>
                      this.handleChangeMoneyRateio('amount', e.floatValue)
                    }
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group with-label">
                  <label className="text lbl-text">Rateio %</label>
                  <NumberFormat
                    className="form-control"
                    allowNegative={false}
                    fixedDecimalScale={true}
                    decimalSeparator={'.'}
                    decimalScale={2}
                    suffix={' %'}
                    value={this.props.apportionment.percent}
                    onValueChange={e =>
                      this.handleChangeMoneyRateio('percent', e.floatValue)
                    }
                  />
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group text-center">
                  <button type="submit" className="btn-submit-rateio">
                    {this.props.apportionment.editing ? 'SALVAR' : 'INCLUIR'}
                    <i className="fas fa-plus-circle plus-icon" />
                  </button>
                  {!this.props.apportionment.editing && (
                    <button
                      type="button"
                      className="btn-submit-rateio finalazed"
                      onClick={this.finalaze}
                    >
                      FINALIZAR
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

const mapStateToProps = ({ negotiationReducer, auth, loader }) => {
  return {
    ...negotiationReducer,
    ...auth,
    ...loader
  };
};

export default connect(
  mapStateToProps,
  { ...NegotiationActions }
)(AddNegotiation);
